export default "__VITE_ASSET__761ee9a2__"